import a from "./highrise1715.mjs";
function e(t) {
  return a(this.__data__, t) > -1;
}
export {
  e as default
};
